import React, { useEffect, useState } from "react";
import Icon from "./Icon";
import T from "./translations/Translations";
import TranslationButton from "./formInputs/buttons/TranslationButton";
import "@/styles/TranslationButton.scss";

/**
 * Provide instructions to the user about entering correct credentials on the following login screen
 * @name Interrupt
 * @return {JSX.Element}
 * @constructor
 */
const Interrupt = (): React.JSX.Element => {
    const [langStr, setLangStr] = useState("en");

    useEffect(() => {
        const bodyElement = document.body;
        const originalStyle = bodyElement.getAttribute("style");

        bodyElement.setAttribute(
            "style",
            "font-kerning: normal; font-weight: 500; line-height: 1.2rem; font-size: 0.9rem; font-family: Arial, Helvetica, sans-serif !important"
        );

        return (): void => {
            if (originalStyle !== null) {
                bodyElement.setAttribute("style", originalStyle);
            } else {
                bodyElement.removeAttribute("style");
            }
        };
    }, []);

    return (
        <div
            style={{
                alignItems: "center",
                border: "1px solid grey",
                borderRadius: "10px",
                display: "flex",
                flexDirection: "column",
                height: "90%",
                margin: "0 auto",
                marginTop: "30px",
                padding: "30px 40px",
                width: "85%"
            }}
        >
            <section className="translation-buttons-container" style={{ position: "relative", top: "-42px" }}>
                <TranslationButton
                    className="translation-button"
                    label="English"
                    onClick={() => {
                        setLangStr("en");
                    }}
                />
                <TranslationButton
                    className="translation-button"
                    label="Español"
                    onClick={() => {
                        setLangStr("es");
                    }}
                />
                <TranslationButton
                    className="translation-button"
                    label="普通話"
                    onClick={() => {
                        setLangStr("zh");
                    }}
                />
                <TranslationButton
                    className="translation-button"
                    label="Русский"
                    onClick={() => {
                        setLangStr("ru");
                    }}
                />
            </section>
            <div style={{ height: "220px", marginTop: "-60px" }}>
                <Icon
                    className="ms-3 mt-3 mb-3"
                    height={240}
                    iconName="DOUGLAS_COUNTY_SCHOOL_DISTRICT"
                    title="Douglas County School District"
                    viewBox="0 0 1024 1024"
                    width={240}
                />
            </div>
            <div style={{ height: "20px" }}>&nbsp;</div>
            <div style={{ minWidth: "400px", width: "80%" }}>
                {T({ tKey: "Interrupt_header", langStr })}
                <br />
                <br />
                {T({ tKey: "Interrupt_p1", langStr })}
                <br />
                <br />
                {T({ tKey: "Interrupt_p2", langStr })}
                <br />
                <br />
                {T({ tKey: "Interrupt_p3", langStr })}
                <br />
                <br />
                <i>{T({ tKey: "Interrupt_note", langStr })}</i>
            </div>
            <div style={{ height: "40px" }}>&nbsp;</div>
            <div>
                <a href="/home" rel="noreferrer" target="_blank">
                    <button
                        style={{
                            borderRadius: "10px",
                            borderWidth: 0,
                            background: "#0669B3",
                            boxShadow: "5px 5px 5px #999999",
                            color: "white",
                            fontSize: "1.2rem",
                            fontWeight: "bold",
                            height: "50px",
                            width: "400px"
                        }}
                        type="button"
                    >
                        {T({ tKey: "Interrupt_submit", langStr })}
                    </button>
                </a>
            </div>
        </div>
    );
};

export default Interrupt;
